(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[632],{

/***/ 79409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    id: "logo_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 64.55"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".logo_svg__cls-1{stroke-width:0}"))), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "logo_svg__cls-1",
    d: "M123.28 23.78v1.41h-.51c-1.38 0-2.33.24-2.84.7-.51.47-.76 1.37-.76 2.7v16.94c0 1.41.27 2.35.8 2.82.53.47 1.36.7 2.48.7h.82v1.41h-13.46v-1.41h.78c1.28 0 2.15-.27 2.6-.82.46-.55.68-1.41.68-2.58v-17.1c0-1.17-.24-2.03-.72-2.56-.48-.53-1.4-.8-2.76-.8h-.59v-1.41h13.46zM143.86 23.78c1.38 0 2.64.16 3.78.49 1.13.33 2.1.78 2.89 1.37.8.59 1.41 1.3 1.86 2.15.44.85.66 1.78.66 2.8 0 .91-.18 1.75-.53 2.52-.35.77-.85 1.45-1.49 2.05-.64.6-1.41 1.11-2.31 1.53-.9.42-1.9.72-2.99.9.6.68 1.26 1.49 1.98 2.45.72.95 1.53 2.07 2.45 3.35.94 1.3 1.71 2.33 2.31 3.09.6.76 1.1 1.32 1.51 1.7.4.38.77.62 1.1.72.33.1.68.16 1.08.16h.47v1.41h-7c-.99-.81-2.02-1.97-3.09-3.48-1.07-1.51-2.23-3.19-3.48-5.05-.37-.52-.71-.99-1.04-1.41-.33-.42-.62-.77-.88-1.06-.47-.5-.89-.81-1.27-.96-.38-.14-.96-.21-1.74-.21h-1.37v7.47c0 1.25.26 2.11.78 2.58.52.47 1.41.7 2.66.7h.74v1.41h-13.5v-1.41h.78c1.28 0 2.14-.28 2.58-.84.44-.56.66-1.48.66-2.76V28.59c0-1.36-.28-2.26-.84-2.72-.56-.46-1.51-.68-2.84-.68h-.35v-1.41h16.43zm-4.5 13.11c2.5 0 4.42-.43 5.75-1.29 1.33-.86 2-2.29 2-4.3s-.63-3.43-1.88-4.5c-1.25-1.07-2.93-1.6-5.05-1.6h-3.44v11.7h2.62zM180.05 31.1h-2.43c-.39-2.11-1.16-3.72-2.31-4.81-1.15-1.1-2.58-1.64-4.3-1.64-1.38 0-2.52.37-3.42 1.1-.9.73-1.35 1.7-1.35 2.9 0 .97.31 1.77.94 2.41.63.64 1.67 1.31 3.13 2.01 1.54.76 3.04 1.52 4.5 2.29s2.75 1.61 3.87 2.52c.94.78 1.7 1.61 2.27 2.48.57.87.86 1.94.86 3.19 0 .96-.21 1.9-.63 2.8-.42.9-1.05 1.7-1.9 2.39-.85.69-1.92 1.25-3.23 1.66-1.3.42-2.84.63-4.62.63-1.96 0-3.74-.16-5.36-.49-1.62-.33-3.13-.82-4.54-1.47l-.43-6.22h2.62c.6 2.37 1.49 4.1 2.66 5.16 1.17 1.07 2.71 1.6 4.62 1.6 1.75 0 3.08-.38 3.99-1.15.91-.77 1.37-1.82 1.37-3.15 0-.18-.02-.42-.06-.7-.04-.29-.12-.6-.25-.94-.13-.34-.33-.68-.59-1.02-.26-.34-.61-.66-1.06-.98-.81-.57-1.66-1.08-2.56-1.51-.9-.43-1.81-.86-2.72-1.29-.91-.43-1.81-.88-2.7-1.35a15.51 15.51 0 01-2.54-1.68c-1.07-.83-1.78-1.7-2.13-2.58-.35-.89-.53-1.72-.53-2.5 0-1.04.2-2.02.61-2.93.4-.91 1.01-1.71 1.82-2.39.81-.68 1.83-1.21 3.07-1.6 1.24-.39 2.69-.59 4.36-.59.81 0 1.56.04 2.27.12s1.39.2 2.05.37c.66.17 1.34.39 2.03.67.69.27 1.45.61 2.29 1l.31 5.71zM212.72 23.78v6.06h-2.11c-.39-.89-.79-1.63-1.19-2.23-.4-.6-.87-1.08-1.39-1.43-.52-.35-1.15-.61-1.9-.76s-1.64-.24-2.68-.24h-.74v20.38c0 1.33.25 2.24.74 2.74.5.5 1.34.74 2.54.74h.74v1.41h-13.34v-1.41h.66c1.3 0 2.19-.27 2.66-.8.47-.53.7-1.43.7-2.68V25.18h-.74c-1.07 0-1.97.08-2.7.24s-1.36.42-1.9.78c-.53.37-1 .84-1.39 1.43-.39.59-.78 1.32-1.17 2.21h-2.11v-6.06h25.31zM300.51 23.78v1.41h-.9c-1.28 0-2.17.26-2.66.78-.5.52-.74 1.47-.74 2.86v16.12c0 1.54.35 2.61 1.06 3.21.7.6 1.83.9 3.36.9 1.17 0 2.16-.12 2.97-.35.81-.23 1.51-.57 2.11-1.02.6-.44 1.16-1 1.68-1.68.52-.68 1-1.47 1.45-2.39h2.43l-1.72 6.85h-22.5v-1.41h.7c1.1 0 1.9-.24 2.41-.72.51-.48.76-1.43.76-2.84V28.56c0-1.25-.25-2.13-.74-2.62-.5-.5-1.33-.74-2.5-.74h-.63v-1.41h13.46zM330.75 23.78l9.04 22.61c.21.55.42.98.65 1.31.22.33.46.59.72.78.26.2.57.33.92.41.35.08.78.13 1.27.16v1.41h-13.3v-1.41h.55c2.56 0 3.83-.64 3.83-1.92 0-.29-.1-.7-.29-1.25-.2-.55-.42-1.15-.68-1.8-.26-.65-.52-1.3-.76-1.94-.25-.64-.48-1.22-.69-1.74h-9.82c-.16.5-.35 1.03-.57 1.6-.22.57-.43 1.13-.63 1.68s-.37 1.08-.51 1.58c-.14.51-.22.96-.22 1.35 0 .68.3 1.25.9 1.72.6.47 1.54.7 2.82.7h.16v1.41h-10.06v-1.41c1.3-.18 2.28-.6 2.93-1.25.18-.16.36-.35.53-.57.17-.22.35-.51.55-.86.2-.35.42-.81.67-1.39.25-.57.54-1.29.88-2.15l6.53-16.82-.86-2.23h5.44zm-7.86 14.71h8.37l-4.38-10.72-3.99 10.72zM366.83 31.1h-2.43c-.39-2.11-1.16-3.72-2.31-4.81s-2.58-1.64-4.3-1.64c-1.38 0-2.52.37-3.42 1.1-.9.73-1.35 1.7-1.35 2.9 0 .97.31 1.77.94 2.41.63.64 1.67 1.31 3.13 2.01 1.54.76 3.04 1.52 4.5 2.29s2.75 1.61 3.87 2.52c.94.78 1.7 1.61 2.27 2.48.57.87.86 1.94.86 3.19 0 .96-.21 1.9-.63 2.8-.42.9-1.05 1.7-1.9 2.39-.85.69-1.92 1.25-3.23 1.66-1.3.42-2.84.63-4.62.63-1.96 0-3.74-.16-5.36-.49-1.62-.33-3.13-.82-4.54-1.47l-.43-6.22h2.62c.6 2.37 1.49 4.1 2.66 5.16 1.17 1.07 2.71 1.6 4.62 1.6 1.75 0 3.08-.38 3.99-1.15.91-.77 1.37-1.82 1.37-3.15 0-.18-.02-.42-.06-.7-.04-.29-.12-.6-.25-.94-.13-.34-.33-.68-.59-1.02-.26-.34-.61-.66-1.06-.98-.81-.57-1.66-1.08-2.56-1.51-.9-.43-1.81-.86-2.72-1.29-.91-.43-1.81-.88-2.7-1.35s-1.73-1.03-2.54-1.68c-1.07-.83-1.78-1.7-2.13-2.58-.35-.89-.53-1.72-.53-2.5 0-1.04.2-2.02.61-2.93.4-.91 1.01-1.71 1.82-2.39.81-.68 1.83-1.21 3.07-1.6 1.24-.39 2.69-.59 4.36-.59.81 0 1.56.04 2.27.12s1.39.2 2.05.37c.66.17 1.34.39 2.03.67.69.27 1.45.61 2.29 1l.31 5.71zM394.06 31.1h-2.43c-.39-2.11-1.16-3.72-2.31-4.81-1.15-1.1-2.58-1.64-4.3-1.64-1.38 0-2.52.37-3.42 1.1-.9.73-1.35 1.7-1.35 2.9 0 .97.31 1.77.94 2.41.63.64 1.67 1.31 3.13 2.01 1.54.76 3.04 1.52 4.5 2.29s2.75 1.61 3.87 2.52c.94.78 1.69 1.61 2.27 2.48.57.87.86 1.94.86 3.19 0 .96-.21 1.9-.63 2.8s-1.05 1.7-1.9 2.39c-.85.69-1.92 1.25-3.23 1.66s-2.84.63-4.62.63c-1.96 0-3.74-.16-5.36-.49s-3.13-.82-4.54-1.47l-.43-6.22h2.62c.6 2.37 1.49 4.1 2.66 5.16 1.17 1.07 2.71 1.6 4.62 1.6 1.75 0 3.08-.38 3.99-1.15.91-.77 1.37-1.82 1.37-3.15 0-.18-.02-.42-.06-.7-.04-.29-.12-.6-.25-.94-.13-.34-.33-.68-.59-1.02-.26-.34-.61-.66-1.06-.98-.81-.57-1.66-1.08-2.56-1.51s-1.81-.86-2.72-1.29c-.91-.43-1.81-.88-2.7-1.35s-1.73-1.03-2.54-1.68c-1.07-.83-1.78-1.7-2.13-2.58-.35-.89-.53-1.72-.53-2.5 0-1.04.2-2.02.61-2.93.4-.91 1.01-1.71 1.82-2.39.81-.68 1.83-1.21 3.07-1.6 1.24-.39 2.69-.59 4.36-.59.81 0 1.56.04 2.27.12a15.136 15.136 0 014.08 1.04c.69.27 1.45.61 2.29 1l.31 5.71zM408.57 48.04c0 .81-.27 1.49-.82 2.05s-1.23.84-2.03.84-1.49-.28-2.05-.84-.84-1.25-.84-2.05.28-1.49.84-2.03c.56-.55 1.25-.82 2.05-.82s1.49.27 2.03.82c.55.55.82 1.23.82 2.03zM441.16 31.41h-2.35c-.68-2.11-1.78-3.77-3.31-4.97-1.53-1.2-3.28-1.8-5.26-1.8-1.64 0-3.03.37-4.15 1.1-1.12.73-2.02 1.76-2.7 3.09-1.15 2.22-1.72 5.01-1.72 8.37 0 1.85.21 3.54.65 5.07.43 1.53 1.04 2.83 1.84 3.91s1.77 1.92 2.91 2.52c1.15.6 2.44.9 3.87.9 1.07 0 2.07-.17 3.01-.51.94-.34 1.77-.82 2.49-1.45.72-.63 1.3-1.38 1.76-2.27.46-.89.75-1.89.88-3.01h2.58l-.39 6.06c-1.72.84-3.57 1.47-5.56 1.92-1.98.44-4.03.67-6.14.67-2.27 0-4.27-.34-6.01-1.02s-3.19-1.62-4.38-2.82c-1.19-1.2-2.08-2.61-2.68-4.24-.6-1.63-.9-3.4-.9-5.3 0-2.32.42-4.38 1.25-6.16.83-1.79 1.94-3.29 3.32-4.52 1.38-1.23 2.97-2.15 4.75-2.78 1.79-.63 3.63-.94 5.54-.94 3.13 0 6.38.72 9.74 2.15l.94 6.02zM477.08 36.5c0 1.93-.35 3.77-1.06 5.52-.7 1.75-1.7 3.29-2.97 4.62-1.28 1.33-2.83 2.39-4.66 3.19-1.83.8-3.85 1.19-6.06 1.19-2.09 0-4-.35-5.75-1.06-1.75-.7-3.25-1.67-4.5-2.9a13.067 13.067 0 01-2.91-4.32c-.69-1.66-1.04-3.42-1.04-5.3 0-1.98.38-3.83 1.14-5.56.76-1.72 1.81-3.22 3.15-4.5 1.34-1.28 2.92-2.29 4.73-3.03 1.81-.74 3.78-1.11 5.89-1.11s3.91.34 5.63 1.02c1.72.68 3.2 1.62 4.44 2.82 1.24 1.2 2.21 2.6 2.91 4.21.7 1.6 1.06 3.34 1.06 5.22zM463 49.6c1.25 0 2.37-.28 3.36-.84.99-.56 1.83-1.36 2.52-2.41.69-1.04 1.22-2.28 1.59-3.72.36-1.43.55-3.04.55-4.81s-.18-3.42-.53-5.01c-.35-1.59-.88-2.99-1.59-4.21-.7-1.21-1.59-2.18-2.66-2.9-1.07-.72-2.33-1.08-3.8-1.08-1.23 0-2.35.27-3.36.82-1.02.55-1.88 1.34-2.6 2.37-.72 1.03-1.28 2.28-1.68 3.76-.41 1.47-.61 3.12-.61 4.95s.21 3.66.65 5.26c.43 1.6 1.03 2.98 1.8 4.13s1.7 2.05 2.78 2.7 2.28.98 3.58.98zM494.06 23.78v.16c0 .65.07 1.33.2 2.03.13.7.33 1.47.61 2.31.27.84.61 1.74 1.02 2.72.41.98.89 2.07 1.47 3.27 1.17 2.45 2.08 4.37 2.72 5.75.64 1.38 1.04 2.31 1.19 2.78 1.15-2.58 2.61-5.78 4.38-9.59.91-1.96 1.6-3.59 2.05-4.91.46-1.32.68-2.39.68-3.23 0-.21 0-.42-.02-.65a6.82 6.82 0 00-.06-.65h9.74v1.41h-.78c-1.17 0-2.03.22-2.58.65-.55.43-.82 1.04-.82 1.82 0 .21.12 1.17.35 2.9l1.84 13.89c.16 1.25.33 2.14.53 2.66s.42.91.68 1.17c.26.26.61.46 1.04.59.43.13 1 .2 1.7.2v1.41h-13.07v-1.41c1.49 0 2.54-.22 3.17-.65.63-.43.94-1.26.94-2.48 0-.23 0-.5-.02-.78-.01-.29-.05-.68-.12-1.17-.07-.5-.14-1.12-.24-1.88-.09-.76-.21-1.73-.37-2.93-.16-1.2-.35-2.65-.57-4.34-.22-1.7-.48-3.73-.76-6.1h-.08c-.1.5-.48 1.53-1.13 3.11-.65 1.58-1.64 3.76-2.97 6.55-2.58 5.48-4.11 9.51-4.58 12.09h-1.64c-.03-.78-.37-2.01-1.02-3.68-.65-1.67-1.62-3.8-2.9-6.38-1.28-2.61-2.35-4.87-3.21-6.79-.86-1.92-1.5-3.53-1.92-4.83h-.08l-2.15 14.16c-.03.16-.06.37-.1.63a16.768 16.768 0 00-.16 1.68c-.01.29-.02.55-.02.78 0 1.04.31 1.81.92 2.29.61.48 1.62.72 3.03.72h.43v1.41h-9.62v-1.41c.81 0 1.4-.08 1.78-.25.38-.17.7-.42.96-.76s.49-.86.7-1.56c.21-.7.4-1.66.59-2.86.7-4.59 1.27-8.19 1.7-10.8.43-2.61.65-4.25.65-4.93 0-.99-.31-1.69-.94-2.09-.63-.4-1.57-.61-2.82-.61v-1.41h9.66zM278.2 24.57h-3.17c-.92-2.85-2.4-5.08-4.46-6.7s-4.43-2.43-7.1-2.43c-2.22 0-4.08.49-5.6 1.48-1.51.99-2.73 2.38-3.64 4.17-1.55 2.99-2.32 6.76-2.32 11.3 0 2.5.29 4.78.87 6.84.58 2.06 1.41 3.82 2.48 5.28 1.07 1.46 2.38 2.6 3.93 3.4 1.55.81 3.29 1.21 5.23 1.21 1.44 0 2.8-.23 4.06-.69s2.38-1.11 3.35-1.95c.97-.84 1.76-1.86 2.38-3.06.61-1.2 1.01-2.55 1.19-4.06h3.48l-.53 8.18c-2.32 1.13-4.82 1.99-7.5 2.59-2.68.6-5.44.9-8.29.9-3.06 0-5.76-.46-8.1-1.37-2.34-.92-4.31-2.18-5.91-3.8-1.6-1.62-2.81-3.53-3.62-5.73-.81-2.2-1.21-4.58-1.21-7.15 0-3.13.56-5.9 1.69-8.31s2.62-4.44 4.49-6.1c1.86-1.65 4-2.9 6.41-3.75 2.41-.84 4.9-1.27 7.47-1.27 4.22 0 8.6.97 13.14 2.9l1.27 8.13zM103.08 15.01v7.71h-3.06c-.84-2.01-1.89-3.47-3.14-4.41-1.25-.93-2.77-1.4-4.57-1.4h-8.18v14.68h5.7c1.9 0 3.31-.37 4.22-1.11s1.5-2.13 1.74-4.17h2.96v12.41h-2.96c-.21-1.97-.82-3.33-1.82-4.09-1-.76-2.38-1.14-4.14-1.14h-5.7v11.03c0 1.58.31 2.75.92 3.51.62.76 1.75 1.14 3.4 1.14.11 0 .27 0 .5-.03.23-.02.43-.03.61-.03v1.9h-18v-1.9h.53c1.02 0 1.84-.09 2.45-.26.62-.18 1.08-.42 1.4-.74.7-.7 1.06-2.01 1.06-3.91V21.55c0-1.69-.33-2.88-.98-3.59-.65-.7-1.82-1.06-3.51-1.06h-.95V15h31.51zM234.25 36.04v3.8H222.2v-3.8h12.05z"
  })), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "logo_svg__cls-1",
    d: "M24.14 4.2C22.92 1.64 20.31 0 17.45 0H12.59l6.7 32.27-6.7 32.27H17.45c2.86 0 5.48-1.64 6.7-4.2l14.97-28.07L24.14 4.2z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "logo_svg__cls-1",
    d: "M42.46 34.22H1.95C.87 34.22 0 33.35 0 32.27s.87-1.95 1.95-1.95h40.51c1.08 0 1.95.87 1.95 1.95s-.87 1.95-1.95 1.95z"
  }))));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgLogo);

/***/ }),

/***/ 57907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ FlightSearchAutocomplete; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43665);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90629);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61903);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98456);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _utils_store_features_flightSegmentsSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2818);
/* harmony import */ var _FlightSearchAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18074);
/* harmony import */ var _FlightSearchAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_FlightSearchAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _api_flight_autocomplete__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35381);










var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    shape: {
        borderRadius: 12
    },
    palette: {
        primary: {
            main: "#00454A"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
var FlightSearchAutocomplete = function(param) {
    var label = param.label, _showLabel = param.showLabel, showLabel = _showLabel === void 0 ? true : _showLabel, icon = param.icon, name = param.name, setFieldValue = param.setFieldValue, error = param.error, patch = param.patch;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), options = ref[0], setOptions = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(undefined), patched = ref2[0], setPatched = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var setInputValue = function(value) {
        setLoading(true);
        (0,_api_flight_autocomplete__WEBPACK_IMPORTED_MODULE_6__/* .getFlightAirportsAutocomplete */ ._)(value).then(function(airports) {
            setOptions(airports);
            setLoading(false);
        });
    };
    var setValue = function(newValue) {
        setFieldValue(name, newValue);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!!(patch === null || patch === void 0 ? void 0 : patch.value) && typeof patch.value === "string") {
            setPatched(true);
            (0,_api_flight_autocomplete__WEBPACK_IMPORTED_MODULE_6__/* .getFlightAirportsAutocomplete */ ._)(patch.value).then(function(airports) {
                var airport = patch.exact && (airports === null || airports === void 0 ? void 0 : airports.length) > 1 ? airports.find(function(a) {
                    return !a.Name.includes("All airports") && a.Iata === patch.value;
                }) : airports.find(function(a) {
                    // a.Iata === patch.value ||
                    // patch.value
                    //   .replaceAll(' ', '')
                    //   .includes(a.city.replaceAll(' ', ''))
                    var cleanedValue = patch.value.replace(/ /g, "");
                    var cleanedCity = a.city.replace(/ /g, "");
                    return a.Iata === patch.value || cleanedValue.includes(cleanedCity);
                });
                if (airport) {
                    airport.exact = patch.exact;
                    setValue(airport);
                    setPatched(false);
                    dispatch((0,_utils_store_features_flightSegmentsSlice__WEBPACK_IMPORTED_MODULE_4__/* .setSegments */ .wc)({
                        selectedAirport: airport,
                        allAirports: airports
                    }));
                }
            });
        } else {
            setPatched(true);
        }
    }, [
        patch.value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        disablePortal: false,
        value: typeof patch.value !== "string" ? patch.value : null,
        onChange: function(event, newValue) {
            setValue(newValue);
        },
        open: open,
        onClose: function() {
            setOpen(false);
            window.parent.postMessage(JSON.stringify({
                height: 150
            }), "*");
        },
        isOptionEqualToValue: function(evt) {
            return evt.Name;
        },
        filterOptions: function(x) {
            return x;
        },
        onKeyDown: function() {
            setPatched(false);
            setOpen(true);
        },
        onInputChange: (0,_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(event, newInputValue, reason) {
            if (reason === "input") {
                var ref;
                if (newInputValue !== ((ref = patch.value) === null || ref === void 0 ? void 0 : ref.Name) && newInputValue.length >= 3) {
                    setInputValue(newInputValue);
                    return;
                }
                if (patched === false && newInputValue.length >= 3) {
                    setInputValue(newInputValue);
                    window.parent.postMessage(JSON.stringify({
                        height: 400
                    }), "*");
                }
            }
        }, 500),
        PaperComponent: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_FlightSearchAutocomplete_module_scss__WEBPACK_IMPORTED_MODULE_10___default().option), "font-libre"),
                children: children
            });
        },
        options: options,
        groupBy: function(option) {
            return (option.cityName || option.regionName) + (option.countryName ? " (" + option.countryName + ")" : "");
        },
        onBlur: function() {
            return setOptions([]);
        },
        // getOptionLabel={(option) => (option.fullName || option.name) + option.countryName ? ' (' + option.countryName + ')' : '(none)'}
        getOptionLabel: function(option) {
            return option.fullName || option.name;
        },
        fullWidth: true,
        renderInput: function(params) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                theme: theme,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, params), {
                    error: error,
                    placeholder: label,
                    label: showLabel ? label : undefined,
                    InputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, params.InputProps), {
                        startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: icon
                        }),
                        endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                color: "inherit",
                                size: 20
                            }) : null
                        })
                    })
                }))
            });
        }
    });
};


/***/ }),

/***/ 35381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getFlightAirportsAutocomplete; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14251);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22550);


/**
 * @typedef {Object} DisplayPlaceType
 * @property {string} [displayName]
 * @property {string} [type]
 */ /**
 * Airport item returned by flight autocomplete API
 * @typedef {Object} Airport
 * @property {string} [cityName]
 * @property {string} [countryName]
 * @property {DisplayPlaceType} [displayPlaceType]
 * @property {string} [fullName]
 * @property {string} [iataCode]
 * @property {boolean} [isMetro]
 * @property {int} [placeId]
 * @property {string} [primaryPlaceType]    {'city'|'airport'|'country'}
 * @property {string} [regionName]
 * @property {string} [Iata]
 * @property {string} [Name]
 * @property {string} [city]
 */ /**
 * Fetch airports for the Flight Search autocomplete.
 *
 * @param {string} value
 * @returns {Promise<Airport[]>}
 */ var getFlightAirportsAutocomplete = function(value) {
    if (!value) {
        return Promise.resolve([]);
    }
    return (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpGet */ .kA)("/api/flight/autocomplete?search=".concat(value)).then(function(response) {
        if (!response.ok) {
            return []; // req failed
        }
        return response.json();
    }).then(function(result) {
        if (!result) {
            // empty response
            return [];
        }
        var airports = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = result[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var airport = _step.value;
                airports.push(airport);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return airports.filter(function(airport) {
            return airport.iataCode;
        }).map(mapAutocompleteResults);
    });
};
var mapAutocompleteResults = function(airport) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        Iata: airport.iataCode,
        Name: airport.fullName,
        city: airport.cityName
    }, airport);
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ CABIN_CLASSES; }
/* harmony export */ });
/* unused harmony export countrySelectOptions */
var CABIN_CLASSES = [
    {
        value: "ECO",
        label: "Economy"
    },
    {
        value: "FLX",
        label: "Premium Economy"
    },
    {
        value: "BIZ",
        label: "Business Class"
    },
    {
        value: "FST",
        label: "First Class"
    }, 
];
var countrySelectOptions = [
    {
        value: "AE",
        label: "United Arab Emirates"
    },
    {
        value: "AR",
        label: "Argentina"
    },
    {
        value: "AT",
        label: "Austria"
    },
    {
        value: "AU",
        label: "Australia"
    },
    {
        value: "BE",
        label: "Belgium"
    },
    {
        value: "BO",
        label: "Bolivia"
    },
    {
        value: "BR",
        label: "Brazil"
    },
    {
        value: "CA",
        label: "Canada"
    },
    {
        value: "CH",
        label: "Switzerland"
    },
    {
        value: "CL",
        label: "Chile"
    },
    {
        value: "CO",
        label: "Colombia"
    },
    {
        value: "CR",
        label: "Costa Rica"
    },
    {
        value: "CZ",
        label: "Czechia"
    },
    {
        value: "DE",
        label: "Germany"
    },
    {
        value: "DK",
        label: "Denmark"
    },
    {
        value: "DO",
        label: "Dominican Republic"
    },
    {
        value: "EC",
        label: "Ecuador"
    },
    {
        value: "ES",
        label: "Spain"
    },
    {
        value: "FI",
        label: "Finland"
    },
    {
        value: "FR",
        label: "France"
    },
    {
        value: "GB",
        label: "United Kingdom"
    },
    {
        value: "GR",
        label: "Greece"
    },
    {
        value: "GT",
        label: "Guatemala"
    },
    {
        value: "HK",
        label: "Hong Kong"
    },
    {
        value: "HN",
        label: "Honduras"
    },
    {
        value: "ID",
        label: "Indonesia"
    },
    {
        value: "IE",
        label: "Ireland"
    },
    {
        value: "IL",
        label: "Israel"
    },
    {
        value: "IN",
        label: "India"
    },
    {
        value: "IT",
        label: "Italia"
    },
    {
        value: "JP",
        label: "Japan"
    },
    {
        value: "KR",
        label: "South Korea"
    },
    {
        value: "MX",
        label: "M\xe9xico"
    },
    {
        value: "MY",
        label: "Malaysia"
    },
    {
        value: "NI",
        label: "Nicaragua"
    },
    {
        value: "NL",
        label: "Netherlands"
    },
    {
        value: "NO",
        label: "Norway"
    },
    {
        value: "NZ",
        label: "New Zealand"
    },
    {
        value: "PA",
        label: "Panama"
    },
    {
        value: "PE",
        label: "Peru"
    },
    {
        value: "PH",
        label: "Philippines"
    },
    {
        value: "PL",
        label: "Poland"
    },
    {
        value: "PR",
        label: "Puerto Rico"
    },
    {
        value: "PT",
        label: "Portugal"
    },
    {
        value: "PY",
        label: "Paraguay"
    },
    {
        value: "QA",
        label: "Qatar"
    },
    {
        value: "RO",
        label: "Romania"
    },
    {
        value: "SA",
        label: "Saudi Arabia"
    },
    {
        value: "SE",
        label: "Sweden"
    },
    {
        value: "SG",
        label: "Singapore"
    },
    {
        value: "SV",
        label: "El Salvador"
    },
    {
        value: "TH",
        label: "Thailand"
    },
    {
        value: "TR",
        label: "Turkey"
    },
    {
        value: "TW",
        label: "Taiwan"
    },
    {
        value: "UA",
        label: "Ukraine"
    },
    {
        value: "US",
        label: "United States"
    },
    {
        value: "UY",
        label: "Uruguay"
    },
    {
        value: "VN",
        label: "Vietnam"
    },
    {
        value: "ZA",
        label: "South Africa"
    }, 
];


/***/ }),

/***/ 22550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ko": function() { return /* binding */ httpPost; },
/* harmony export */   "P3": function() { return /* binding */ httpDelete; },
/* harmony export */   "Wi": function() { return /* binding */ fileUpload; },
/* harmony export */   "e8": function() { return /* binding */ httpPut; },
/* harmony export */   "kA": function() { return /* binding */ httpGet; }
/* harmony export */ });
var httpGet = function(url) {
    var skipEncode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (skipEncode) {
        return fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            }
        });
    }
    return fetch(encodeURI(url), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
        }
    });
};
var httpDelete = function(url) {
    return fetch(encodeURI(url), {
        method: "DELETE"
    });
};
var httpPost = function(url, body) {
    return fetch(encodeURI(url), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
        },
        body: JSON.stringify(body)
    });
};
var fileUpload = function(url, body) {
    return fetch(encodeURI(url), {
        method: "POST",
        body: body
    });
};
var httpPut = function(url, body) {
    return fetch(encodeURI(url), {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
        },
        body: JSON.stringify(body)
    });
};


/***/ }),

/***/ 18074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"FlightSearchAutocomplete_option__gvCK4"};

/***/ }),

/***/ 43587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__63Z_P","logoMobile":"Logo_logoMobile___M1Ng","logoMobileBlack":"Logo_logoMobileBlack__JLwLw","logoBlack":"Logo_logoBlack__Xd_NE"};

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);